import { redirect } from "react-router-dom";
import { AuthError } from "@/types/errorTypes/authError";
import { apiEndpoints } from "@/services/api/api.ts";
import { AdminPanelCategoryData } from "@/routes/adminPanel/categories/main/types/adminPanelCategoryData.ts";

export const adminPanelCategoryEditAction = async ({
  request,
}: {
  request: Request;
}) => {
  const formData = await request.formData();
  const data = Object.fromEntries(
    formData,
  ) as unknown as AdminPanelCategoryData;
  try {
    const url = new URL(request.url);
    const returnUrl =
      url.searchParams.get("returnUrl") || "/admin-panel/categories";
    const categoryUpdateResult = await apiEndpoints.updateCategory(data);
    if (categoryUpdateResult) {
      return redirect(returnUrl);
    }
    return true;
  } catch (err) {
    throw err;
  }
};
